export function isNumeric(value: string | number) {
    return typeof(value) === 'number'
}